<template>
  <ubi-page-container>
        <template v-slot:page-actions>
          <el-button class="inline">
                <downloadexcel
                    :fetch="exporter"
                    type="xls"
                >
                    {{ $t("portals.report.exportResults") }}
                </downloadexcel>
          </el-button>
        </template>
      <div v-loading="loading"
           :element-loading-text="$t('portals.list.chargementDonnees')">
        <ubi-panel :title="titre" size="sm">
          <template v-slot:left-column>
          <el-row>
            <el-col :lg="24" :md="12">
              <el-row v-if="universClient == 'IMMO'">
                <el-col :span="24">
                  <h3>
                    <span class="badge badge-primary" v-if="post && post.typeOffreLibelle">{{post.typeOffreLibelle}}</span>
                    <span class="badge badge-primary" v-if="post && post.typeBien">{{post.typeBien}}</span>
                  </h3>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24"><br></el-col>
              </el-row>
              <el-row>
                <el-col :lg="24" class="mb-3">
                  <el-row>
                    <el-col><strong>{{ $t("contacts.generalInformation") }}</strong></el-col>
                  </el-row>
                  <el-row>
                    <br>
                  </el-row>
                  <el-row>
                    <el-col :lg="12"><strong>{{ $t("contacts.postReference") }}</strong></el-col>
                    <el-col :lg="12" v-if="post && post.reference">{{post.reference}}</el-col>
                    <el-col :lg="12" v-else>{{ $t("contacts.postEmptyField") }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12"><strong>{{ $t("contacts.postPrice") }}</strong></el-col>
                    <el-col :lg="12" v-if="post && post.prixDisplay">{{post.prixDisplay}}</el-col>
                    <el-col :lg="12" v-else>{{ $t("contacts.postEmptyField") }}</el-col>
                  </el-row>
                  <el-row v-if="universClient == 'IMMO'">
                    <el-col :lg="12"><strong>{{ $t("contacts.postLocation") }}</strong></el-col>
                    <el-col :lg="12" v-if="post && post.donnees.code_postal && post.donnees.ville">{{post.donnees.code_postal.valeur}} {{post.donnees.ville.valeur}}</el-col>
                    <el-col :lg="12" v-else>{{ $t("contacts.postEmptyField") }}</el-col>
                  </el-row>
                </el-col>
              </el-row>

            </el-col>
          </el-row>
          </template>
          <template v-slot:right-column>
            <el-row>
              <el-col :lg="24">
                <div class="text-muted" style="text-align: center;">
                    <el-image
                        v-if="post && post.photoPrincipale" :src="post.photoPrincipale.url"
                    />
                    <ubi-icon v-else class="no-photo" name="camera" size='150' />
                </div>
              </el-col>
            </el-row>
          </template>
        </ubi-panel>

        <el-form @submit.prevent.native="fetchList">
          <ubi-panel style="background-color: #EBF3F2;">
            <ubi-search-container
            :filters="filters"
            @filter="doFilter"
            :defaultFilter="this.filter.preset"
            v-on:resetfilter="doFilter('reset')"
            :more-opened="filter.advanced"
            @update:more-opened="advanced => setFilter({ advanced })">
              <el-form-item :label="$t('general.filters.portalContactEmail')">
                <el-input type="text" @input="setSearch" :value="filter.search" :placeholder="$t('general.filters.adReferencePlaceholder')" />
              </el-form-item>
              <el-form-item :label="$t('general.filters.date')">
                  <el-date-picker
                    type="daterange"
                    :value="filter.beforeContacts || filter.afterContacts ? [
                      filter.beforeContacts || undefined,
                      filter.afterContacts || undefined
                    ] : null"
                    :start-placeholder="$t('general.filters.dateCreationStart')"
                    :end-placeholder="$t('general.filters.dateCreationEnd')"
                    @input="
                      dates => addFilter({ beforeContacts: dates ? dates[0] : null, afterContacts: dates ? dates[1] : null})
                    "
                    format="dd/MM/yyyy"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
              </el-form-item>
            </ubi-search-container>
          </ubi-panel>
        </el-form>
        <ubi-panel>
            <ubi-list-header slot="header"
            :limits="limits"
            :page.sync="page"
            :limit.sync="limit"
            :total="nbResults"
            :sort.sync="sort"
            :sortProperties="sortProperties">></ubi-list-header>
            <el-button type="mini" slot="actions" v-loading="loadingExport">
              <downloadexcel
                  :fetch="exporter"
                  type="xls"
              >
                {{ $t("contacts.exportResults") }}
              </downloadexcel>
            </el-button>
            <ubi-list-footer slot="footer" :limits="limits" :page.sync="page" :limit.sync="limit" :total="nbResults"></ubi-list-footer>
            <el-table ref="table" :data="contacts">
            <el-table-column type="expand">
                <template v-slot="{ row: result }">
                    {{result.commentaire}}
                    <div>
                        <div v-if="result.codePostal">{{ $t("contacts.listTabMailtrackingPostalCode") }} :  {{result.codePostal}}</div>
                        <div v-else>{{ $t("contacts.listTabMailtrackingPostalCode") }} : {{ $t("contacts.listTabMailtrackingNoInformation") }}</div>
                    </div>
                    <div>
                        <div v-if="result.ville">{{ $t("contacts.listTabMailtrackingCity") }} :  {{result.ville}}</div>
                        <div v-else>{{ $t("contacts.listTabMailtrackingCity") }} : {{ $t("contacts.listTabMailtrackingNoInformation") }}</div>
                    </div>
                    <div>
                        <div v-if="result.url">{{ $t("contacts.listTabMailtrackingAdAddress") }} :  <a :href="result.url" target="_blank" rel="noopener">{{result.url}}</a></div>
                        <div v-else>{{ $t("contacts.listTabMailtrackingAdAddress") }} : {{ $t("contacts.listTabMailtrackingNoInformation") }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :label="$t('contacts.listColumnDateAndHour')" width="220">
              <template v-slot="{ row: result }">
                {{ new Date(result.dateEnvoi).toLocaleString()}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('contacts.listColumnPortal')" width="180">
              <template v-slot="{ row: result }">
                {{result.nomDiffuseur}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('contacts.listColumnCivilityLastnameFirstname')" width="200">
              <template v-slot="{ row: result }">
                {{result.identite}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('contacts.listColumnEmail')" width="200">
              <template v-slot="{ row: result }">
                {{result.email}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('contacts.listColumnScoring')" width="180" >
              <template v-slot="{ row: result }">
                <span v-if="result.scoring && result.scoring !== null">{{result.scoring}} / {{result.scoringTotal}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('contacts.listColumnPhoneNumber')" width="180">
              <template v-slot="{ row: result }">
                {{result.telephone}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('contacts.listColumnFormLink')" width="180" fixed="right">
              <template v-slot="{ row: result }">
                <span v-if="result.cryptId !== null"><a :href="getUrlLinkForm(result)" target="_blank">lien du formulaire</a></span>
              </template>
            </el-table-column>
            </el-table>

        </ubi-panel>
      </div>
  </ubi-page-container>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.badge {
    margin-left: 5px;
}
.el-loading-spinner{
    top:10%!important;
}

</style>

<script>
import moment from 'moment'
import { Collapse, CollapseItem, Divider } from 'element-ui'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { getContactsAnnonceEnTete, getContactsAnnonce, exportContacts } from '@/services/contacts'
import PieChart from '@/services/piechart'
import { getPostByReference } from '@/services/posts'
import downloadexcel from 'vue-json-excel'
export default {
  name: 'DetailContactsPerPost',
  inject: ['browserContext'],
  components: {
    PieChart,
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem,
    ElDivider: Divider,
    downloadexcel
  },
  data () {
    return {
      loading: false,
      loadingExport: false,
      offset: 0,
      postReference: this.$route.params.post,
      post: null,
      limits: [10, 10 * 2, 10 * 5, 10 * 10],
      contacts: null,
      enTete: null,
      nbResults: 0,
      titre: null,
      sortProperties: {
        date: this.$t('general.sort.date'),
        nomPortail: this.$t('general.sort.portalName'),
        identite: this.$t('general.sort.contactName')
      },
      nbContactsGeneres: 0,
      totalAnnonces: 0,
      graphData: {},
      filters: []
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    universClient () {
      return this.sitimmoUser.univers
    },
    ...mapState('detailContactsPerPost', ['filter', 'results']),
    ...mapGetters(['getPickerOptionsShortcuts']),
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.fetchList()
        return this.setPage(value)
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setSort(value)
      }
    }
  },
  beforeMount () {
    this.filter.beforeContacts = this.$store.getters['donnees/getContactsDateBefore']
    this.filter.afterContacts = this.$store.getters['donnees/getContactsDateAfter']
    // this.setSort('date');
    this.fetchAnnonce()
    this.fetchList()// this is done inside searchfilter
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('contact_manager_annonces', 'clic', category, this.sitimmoUser.id)
    },
    getUrlLinkForm (result) {
      return `${processEnvConfig.VUE_APP_QUALIFORMA_URL}#/${result.cryptId}`
    },
    async getEnTete () {
      this.enTete = await (getContactsAnnonceEnTete(this.filter, this.postReference))
      if (this.enTete.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
    },
    convertDate: function (date) {
      return 'Le ' + moment(date).format('DD/MM/YYYY à hh:mm:ss')
    },
    ...mapMutations('detailContactsPerPost', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setCategory',
      'setGratuit',
      'setFilter',
      'addFilter',
      'setResults',
      'setOffset',
      'resetFilter'
    ]),
    handleClose (done) {
      this.$confirm(this.$t('general.exitConfirmation'))
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    doFilter (type) {
      switch (type) {
        case 'reset':
          this.resetFilter()
          break
        case 'gratuits':
          this.filter.gratuit = true
          this.setFilter(this.filter)
          break
      }
      this.fetchList()
    },
    async fetchAnnonce () {
      this.post = await (getPostByReference(this.postReference))
      if (this.post && this.post.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      if (this.post && this.post.titre) {
        this.titre = this.post.titre
      }
    },
    async fetchList () {
      this.$store.commit('donnees/SET_CONTACTS_DATE_BEFORE', this.filter.beforeContacts)
      this.$store.commit('donnees/SET_CONTACTS_DATE_AFTER', this.filter.afterContacts)
      // No need to interrupt promises when the router changes...
      this.loading = true
      await (this.getEnTete(this.filter))
      this.nbContactsGeneres = this.enTete.infos.nbContactsGeneres
      const contactsAnnonce = await getContactsAnnonce(this.filter, this.postReference)
      console.log(contactsAnnonce)
      if (contactsAnnonce.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.setResults(contactsAnnonce)
      this.nbResults = this.results.infos.total_items
      this.contacts = this.results.infos.contact_mailtracking
      this.loading = false
    },
    async exporter () {
      this.eventAnalytics('export_contacts_mail')
      this.loadingExport = true
      this.filter.forced = true
      this.filter.exportType = 'contact_mailtracking'
      const res = await exportContacts(this.filter, null, this.postReference)
      this.loadingExport = false
      this.filter.forced = false
      this.$message(res)
    }
  }

}
</script>

<style>
.el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: scroll;
}
</style>
